import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { useEffect } from "react";
import { AdminGuard } from "@/components/AdminGuard";
import { Logo } from "@/components/Logo";
import { AccountMenu } from "@/components/AccountMenu";
import { useAdminStore } from "@/stores/adminStore";
import { useSystemStore } from "@/stores/systemStore";

export const Route = createFileRoute("/admin")({ component: AdminAccess });

function AdminAccess() {
  return (
    <AdminGuard>
      <AdminLayout />
    </AdminGuard>
  );
}
function AdminLayout() {
  const uid = useSystemStore((state) => state.uid);
  useEffect(() => {
    useAdminStore.getState().start();
    return () => useAdminStore.getState().stop();
  }, [uid]);
  return (
    <div dir="ltr" lang="en" className="app-canvas min-h-screen">
      <header className="border-b border-border bg-surface-elevated/90 px-5 py-4 shadow-header">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-5">
          <Logo />
          <span className="app-chip px-2.5 py-1 text-xs font-bold">System Admin</span>
          <nav aria-label="Admin navigation" className="flex gap-2">
            <Link
              to="/admin"
              activeOptions={{ exact: true }}
              activeProps={{ className: "bg-primary-soft text-primary" }}
              className="rounded-xl px-3 py-2 text-sm font-semibold"
            >
              Overview
            </Link>
            <Link
              to="/admin/companies"
              activeProps={{ className: "bg-primary-soft text-primary" }}
              className="rounded-xl px-3 py-2 text-sm font-semibold"
            >
              Companies
            </Link>
            <Link
              to="/admin/leads"
              activeProps={{ className: "bg-primary-soft text-primary" }}
              className="rounded-xl px-3 py-2 text-sm font-semibold"
            >
              Leads
            </Link>
          </nav>
          <div className="ms-auto flex items-center gap-4">
            <Link to="/" className="text-sm text-muted-foreground hover:text-primary">
              Back to Qotta
            </Link>
            <AccountMenu />
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl space-y-6 px-5 py-8 sm:px-8">
        <Outlet />
      </main>
    </div>
  );
}
